import api from "../..";
import type { Course, CourseDetail, GetCourseByIdParams, GetCourseParams } from "./types";
import type { ApiResponse } from "../../types";

export const getCourses = async ({ params }: GetCourseParams = {}): Promise<Course[]> => {

  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => queryParams.append(key, v.toString()));
      } else if (value !== undefined && value !== null) {
        queryParams.append(key, value.toString());
      }
    });
  }

  return await api.get<ApiResponse<Course[]>>(`/course/${queryParams.toString() ? "?" + queryParams.toString() : ""}`)
  .then(res => res.data.data)
  .catch(() => {return []});
};

export const getCourseById = async ({ slugOrId }: GetCourseByIdParams): Promise<CourseDetail | null> => {

  return await api.get<ApiResponse<CourseDetail>>(`/course/${slugOrId}/`)
  .then(res => res.data.data)
  .catch(() => {return null});
};